import { useElementsEnvironmentContext } from '../context';

export const useApiUrl = () => {
  const { isDev, apiUrl } = useElementsEnvironmentContext();
  if (apiUrl) {
    return apiUrl;
  }
  return isDev
    ? 'https://api.dev.getelements.com/v1/graphql'
    : 'https://api.getelements.com/v1/graphql';
};
